import RotateLoader from "react-spinners/RotateLoader";
const Spinner = ({ loading = false, size = 50 }) => {
    return (
        <div className="spinner__loading">
            <RotateLoader
                color={'#BE1E2D'}
                loading={loading}
                size={size}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    )
}

export default Spinner;